import * as React from "react"
import { ShippingMethod } from "../../interfaces/SaleorTypes"
import ShippingMethodCard from "./CheckoutShippingMethodCard"
import styled from "styled-components"

interface ShippingMethodWidgetProps {
  shippingMethods: ShippingMethod[]
  onShippingMethodClick: (method: ShippingMethod) => void
}

const ShippingFormContainer = styled.form`
  row-gap: 1.25em;
  display: flex;
  flex-direction: column;
`

const ShippingMethodWidget: React.FunctionComponent<ShippingMethodWidgetProps> = ({
  shippingMethods,
  onShippingMethodClick,
  ...props
}) => {
  return (
    <div>
      <ShippingFormContainer>
        {shippingMethods &&
          shippingMethods.map((method) => (
            <ShippingMethodCard onShippingMethodClick={onShippingMethodClick} shippingMethod={method} />
          ))}
      </ShippingFormContainer>
    </div>
  )
}

export default ShippingMethodWidget
